import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinRuleEditAggregateTriggers',
  props: {
    tenantId: {
      type: Number,
      required: true
    },
    rule: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: false,
      default: false
    },
    states: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    stateMetricRule: function stateMetricRule() {
      var _this2 = this;

      return [function (v) {
        return _this2.rule.properties.timeTriggerOnly || !!v && !_this2.rule.properties.stateMetrics.find(function (m) {
          return parseInt(m.stateId) === parseInt(v);
        }) || _this2.$i18n_t('Error.DTWINSSTATES_CANNOT_USE_METRIC_AS_AGGTRIGGER');
      }];
    }
  }),
  watch: {
    rule: function rule() {
      this.processAggregates();
    }
  },
  mounted: function mounted() {
    this.processAggregates();
  },
  methods: {
    stateTitle: function stateTitle(stateObj) {
      var state = this.states.find(function (s) {
        return s.id === stateObj.stateId;
      });

      if (state) {
        return state.properties.title;
      }

      return undefined;
    },
    processAggregates: function processAggregates() {
      // change boolean values to string "true"/"false"
      // so they are selectable in the v-select
      // the XAPI offers/changes these trigger-values to proper booleans, but the v-select only has string-values
      // so this little "hack" maps everything back - the rule-trigger handles both cases anyway, and the XAPI maps them back to boolean
      var conditionsDisabled = this.rule.properties.conditionEnabled === false || this.rule.properties.timeTriggerOnly;
      this.rule.properties.triggeredAggregates.forEach(function (agg) {
        agg.triggerValue = conditionsDisabled ? 'true' : "".concat(agg.triggerValue || true).toLowerCase();
      });
    },
    openDigitalTwinOfState: function openDigitalTwinOfState(bindingId) {
      window.open("#".concat(this.$router.currentRoute.path, "?stateId=").concat(bindingId), '_blank');
    }
  }
};